import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';

import {RunnableCommand} from '../../../../../models/runnable-command';
import {AsyncCommandService} from '../../../../../services/async-command/async-command.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {AsyncCommandComponent} from '../async-command.component';
import {AsyncCommand} from '../../../../../models/async-command';

@Component({
  selector: 'app-async-command-run',
  imports: [],
  templateUrl: './async-command-run.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './async-command-run.component.scss'
})
export class AsyncCommandRunComponent implements Dialog {
  runnableCommands: RunnableCommand[] = [];
  runningCommand: AsyncCommand | null = null;
  parentComponent: AsyncCommandComponent | null = null;
  commandIsRunning: boolean = false;

  constructor(
    private asyncCommandService: AsyncCommandService,
    private dialog: DialogService,
  ) {}


  onDialogInit(params: DialogParams): void {
    this.parentComponent = params.data.parentComponent;
    this.runnableCommands = params.data.runnableCommands;
  }

  refresh(): void {
    this.dialog.closeDialog();
    if (this.parentComponent) {
      this.parentComponent.refresh();
    }
  }

  runTask(runnableCommand: RunnableCommand): void {
    this.commandIsRunning = true;
    this.asyncCommandService.run(runnableCommand).subscribe(asyncCommand => {
      this.runningCommand = asyncCommand;
      this.commandIsRunning = false;
    });
  }
}
